import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

const PackageConsumption = ({ data }) => {
  if (data && data.requiredStandardMeters) {
    return (
      <div className="grid grid-cols-2 gap-4 mt-4">
        <div className="flex flex-col gap-1">
          <label 
            htmlFor="used-value" 
            className="mb-1 mt-[0.3vh] inline-block font-['Open_Sans'] text-[12px] font-bold text-[#212529]"
          >
            <FormattedMessage id="usedValue" />
          </label>
          <input
            id="used-value"
            data-cy="used-value"
            type="text"
            value={`${data.requiredStandardMeters.formattedValue}${data.requiredStandardMeters.unit}`}
            readOnly
            disabled
            className="w-full bg-[#f4f3f4] border border-[#ced4da] rounded-[4px] px-4 py-2 text-[14px] text-[rgba(0,0,0,0.38)] font-semibold font-['Open_Sans']"
          />
        </div>
        
        <div className="flex flex-col gap-1">
          <label 
            htmlFor="balance" 
            className="mb-1 mt-[0.3vh] inline-block font-['Open_Sans'] text-[12px] font-bold text-[#212529]"
          >
            <FormattedMessage id="packagesBalance" />
          </label>
          <input
            id="balance"
            data-cy="balance"
            type="text"
            value={`${data.balance?.formattedValue || ''} ${data.balance?.unit || ''}`}
            readOnly
            disabled
            className="w-full bg-[#f4f3f4] border border-[#ced4da] rounded-[4px] px-4 py-2 text-[14px] text-[rgba(0,0,0,0.38)] font-semibold font-['Open_Sans']"
          />
        </div>
      </div>
    );
  }
  
  return (
    <div className="text-[14px] text-gray-500 italic mt-4 font-['Open_Sans']">
      <FormattedMessage id="priceToDefine" />
    </div>
  );
};

PackageConsumption.propTypes = {
  data: PropTypes.object.isRequired,
};

export default PackageConsumption;
